import React from 'react';
import styles from '../assets/styles/LawyerCard.module.css';

const LawyerCard = ({ img, name, title }) => {
  return (
    <div>
      <div className={styles.lawyerCard}>
        <img className={styles.img} src={img} alt={name} />
        <div className={styles.name}>{name}</div>
        <div className={styles.title}>{title}</div>
      </div>
    </div>
  );
};

export default LawyerCard;